import React, { FC, useLayoutEffect } from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { Complete } from '../components/Complete';

export const SubscriptionCancelComplete: FC<{ setting: Setting }> = ({ setting }) => {
  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight

    setting.resize(height)
  }, [])

  return (
    <>
      <div className={classes.mypage_subsc_container}>
        <Complete
          title="毎月お届けプランの解約完了"
          body="登録されている設定は削除されますが、<br/>毎月お届けプランはまたいつでも再開できます。<br/>またのご利用お待ちしております！"
          backTo={`${document.referrer}account`}
          isParent={true}
        />
      </div>
    </>
  );
};
